import { KoButton,  KoDropdown,  KoForm, KoLoader, KoModal, KoNano, KoPagination, KoSearch, KoSkeleton, KoTable, KoText, KoTitle, KoToast, KoTooltips } from 'packages';
import React, { useEffect, useState } from 'react';
import { POLL_COLUMNS } from './constant';
import { PollAPI } from './poll.service';
import styles from './polls.module.scss';
import KoIcon from '@kwapio/icons';
import PollsCurd from './curd';

const Polls = () => {
  const [rowList, setDataList] = useState();
  const [isLoading, setLoading] = useState(false);
  const [counts, setTotalCount] = useState({});
  const [currentRecord, setCurrentRecord] = useState();
  const [isOpen, setModal] = useState(false);
  const [form] = KoForm.useForm();
  const [viewMode, setViewMode] = useState('all');
  const [pagination, setPagination] = useState({
    size: 10,
    offset: 0,
    page: 1
  });

  const [dashboardCards, setDashboardCards ] = useState([]);


  useEffect(() => {
    getPolls(pagination);
  }, []);


  const getPolls = (p) => {
    setLoading(true);
    PollAPI.getPolls(p).then(
      (data) => {
        setDataList();
        setTotalCount();
        // setDashboardCards(data['dashboardCards']);
        setLoading(false);
        setDataList(data['poll']);
        setTotalCount({
          totalCount: data['totalCount'],
          activePolls: data['activePolls'],
          completedPolls: data['completedPolls'],
          draftPolls: data['draftPolls']
        });
        setDashboardCards([
          {
            label: 'Total Poll',
            icon: 'TaskClockCompltionFilled',
            arrow: 'ArrowLineUpFilled',
            description: '8% last month',
            value: data['totalCount']
          },
          {
            label: 'Active Poll',
            icon: 'RevenueFilled',
            value: data['activePolls'],
            description: 'Total created project tasks',
            arrow: 'ArrowLineUpFilled'
          },
          {
            label: 'Completed Poll',
            icon: 'ClockFilled',
            value:  data['completedPolls'],
            description: 'Overall task completion rate',
            arrow: 'ArrowLineUpFilled',
            progress: 30
          },
          {
            label: 'Draft Poll',
            icon: 'ClockFilled',
            value:  data['draftPolls'],
            description: 'Overall task completion rate',
            arrow: 'ArrowLineUpFilled',
            progress: 30
          }
        ]);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const onSearchText=(text)=>{
    let q = pagination;
    if(text){
      q['search'] = text;
    }
    else{
      delete q?.['search'];
    }
    getPolls(q);
  };

  const onSort = (key, type) => {
    let q = pagination;
    q['sort'] = `${key}:${type}`;
    getPolls(q);
  };

  const onPagination = (page, other) => {
    const query = {
      size: other,
      page: page,
      offset: (page - 1) * other
    };
    const pQuery = Object.assign(pagination, query);
    setPagination(pQuery);
    getPolls(pQuery);
  };

  const setCurrentRecordModify =(data)=>{
    setCurrentRecord(data);
  };

  const columnsRight = [{
	  title: '',
	  dataIndex: 'x',
	  key: 'x',
	  fixed: 'right',
	  width: 80,
	  render: (text, row) => {
	    return <div className={`${styles.circle} tableBtn columnsRight`} onClick={() => setCurrentRecordModify(row)}>
        <KoTooltips title={'Edit'}>
	      <KoButton  className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'EditOutlined'}/>} onClick={() => setModal(true)}/>
        </KoTooltips>
	       <KoTooltips title={'Delete'}>
	      <KoButton  className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'DeleteOutlined'}/>} onClick={() => setModal(true)}/>
        </KoTooltips>
	    </div>;
	  }
  }];


  const handleFinish = (values => {
    setLoading(true);
   
    if (!currentRecord?.pollId) {
      values['pollId'] = KoNano('POL');
    }
  
    PollAPI.createPoll(values, currentRecord?.pollId).then(
      (data) => {
        setLoading(false);
        setModal(false);
        form.resetFields();
        KoToast.success(`Poll created successfully! ${values.name}!`); ;
        getPolls();
      },
      
      (err) => {
        setLoading(false);
      }
    );
  });


  const [loadingCards] = useState(false);

  const viewModes = [
    { key: 'all', label: 'All Polls' },
    { key: 0, label: 'Draft' },
    { key: 1, label: 'Active' },
    { key: 2, label: 'Expired' }
  ];
  
  return (
    <div className={styles.wrapper}>
      {isLoading && <KoLoader/>}
      <div className={styles.header}>
        <div className={styles.contentBox}>
          {
            !loadingCards && dashboardCards?.length > 0 && dashboardCards.map((i) => <div key={i} className={styles.card}>
              <div className={styles.icon}>
                <KoIcon name={i.icon} width={46} height={46} />
              </div>
              <div className={styles.mycontent}>
                <KoText className={styles.label} text={i.label} />
                <KoTitle level={1} className={styles.value} text={i.value} />
              </div>
            </div>)
          }
          {
            loadingCards && [1, 2, 3].map((i) => <KoSkeleton active={true} key={i} type={'card'} />)
          }
        </div>
      </div>
      <div className={`${styles.content} tableCard`}>
        <div className={styles.tableHeader}>
          <KoTitle level={4} text={'Polls'} />
          <div className={styles.actions}>
            <KoSearch placeholder={'Search'} onSearch={onSearchText} />
            <KoButton label='Create Poll' type='primary' icon={<KoIcon name='PlusOutlined' color='#FFF' />} onClick={() => setModal(true)} />
            <KoDropdown
              menu={{
                items: viewModes,
                onClick: ({ key }) => setViewMode(key)
              }}
              overlayClassName={styles.actionDropdown}
              placement="bottomRight">
              <div className={styles.viewMode}>
                <KoText text={viewModes.find(item => item.key === viewMode).label} />
                <KoIcon name="DownArrowOutlined" color="#004b50" width={10} height={10} />
              </div>
            </KoDropdown>
          </div>
        </div>
        <KoTable rowKey='pollId' data={{ columns: POLL_COLUMNS, rows: rowList }} onSort={onSort}
          extraColumnsRight={columnsRight} maxHeight={100} />
        <KoPagination current={parseInt(pagination.page) || 1}
          total={counts?.totalCount}
          showTotal={(total, range) =>
				`Displaying records ${range[0]}-${range[1]} of ${total}`
          }
          pageSize={pagination.size}
          defaultCurrent={pagination.page}
          onChange={onPagination}
          showQuickJumper={false}
          simple={false}
          responsive={false} />

      </div>
      <KoModal
        title={currentRecord?.pollId ? `Update Poll ${currentRecord?.profile?.firstName?.toUpperCase()}` : 'Create Poll'}
        centered
        open={isOpen}
        afterClose={() => {setCurrentRecord();}}
        handleOk={() => { setCurrentRecord(); setModal(false); }}
        onClose={() => { setCurrentRecord(); setModal(false); }}
        width={'70vw'}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setModal(!isOpen)} />,
          <KoButton key='create' loading={isLoading} type='primary' label={`${currentRecord?.pollId ? 'Update' : 'Create'}`}
            onClick={() => form.submit()} />
        ]}
      >
        {isLoading && <KoLoader circle={false} />}
        <PollsCurd initialValues={currentRecord} form={form} handleFinish={handleFinish}  getPolls={getPolls} setModal={setModal}/>
      </KoModal>
    </div>
  );
};

export default Polls;
